<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                  <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                      <v-toolbar color="grey lighten-3" elevation="1">
                          <bc-btn-back></bc-btn-back>
                          <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <bc-modal-print
                              ref="print"
                              @close-method="file_name = null, $refs.print.close()"
                              :file-name="file_name"
                              :no-button="true"
                          ></bc-modal-print>
                          <bc-btn-refresh v-if="subscription_plan.plan_id && subscription_plan.plan_id > 0"
                                @invoke-method="dbGetSubscriptionPlan(true)"
                            ></bc-btn-refresh>
                          <v-menu left content-class="no-stripe" v-if="subscription_plan.plan_id && subscription_plan.plan_id > 0">
                              <template slot="activator">
                                  <v-btn icon>
                                      <v-icon>more_vert</v-icon>
                                  </v-btn>
                              </template>
                              <v-list>
                                  <v-list-tile @click="printPDF()">
                                      <v-list-tile-title>
                                          Print
                                      </v-list-tile-title>
                                  </v-list-tile>
                                  <template v-if="hasPerm('subscription_plans.update')">
                                      <v-divider class="ml-3 my-0"></v-divider>

                                      <div v-for="item in subscription_plan_status_options" :key="item.option_id">
                                      <v-list-tile @click="changeStatus(item)" v-if="item.option_id != subscription_plan.status_id">
                                          <v-list-tile-title>
                                              {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                          </v-list-tile-title>
                                      </v-list-tile>
                                      </div>

                                  </template>
                                  <template v-if="hasPerm('subscription_plans.delete')">
                                      <v-divider class="ml-3 my-0"></v-divider>
                                      <v-list-tile @click="$refs.delete_subscription_plan.openDialog()">
                                          <v-list-tile-title>
                                              Delete
                                          </v-list-tile-title>
                                      </v-list-tile>
                                  </template>
                              </v-list>
                          </v-menu>
                          <bc-tooltip>
                              <template slot="activator">
                                  <v-btn
                                      icon
                                      @mouseup.left="$router.push({ name: 'subscription_plans' })"
                                  >
                                      <v-icon>close</v-icon>
                                  </v-btn>
                              </template>
                              {{ $t('lang.back_to_list') }}
                          </bc-tooltip>
                      </v-toolbar>
                  </v-layout>
              </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="subscription_plan.status" class="ribbon ribbon-top-right" :class="`ribbon-${subscription_plan.status_class}`"><span class="ribbon-span">{{ subscription_plan.status }}</span></div>
                        <v-form ref="formSubscriptionPlan">
							<v-flex xs12>
								<v-text-field
									v-focus="subscription_plan_dialog"
									v-model="subscription_plan.plan_id"
									:label="`${$t('lang.plan_id')} *`"
									:rules="ifValid('subscription_plan.plan_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="subscription_plan.plan_code"
									:label="`${$t('lang.plan_code')} *`"
									:counter="showCounter(subscription_plan.plan_code, 'subscription_plan.plan_code')"
									:rules="ifValid('subscription_plan.plan_code')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="subscription_plan.plan_name"
									:label="`${$t('lang.plan_name')} *`"
									:counter="showCounter(subscription_plan.plan_name, 'subscription_plan.plan_name')"
									:rules="ifValid('subscription_plan.plan_name')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="subscription_plan.description"
									:label="$t('lang.description')"
									auto-grow
									rows="1"
									:rules="ifValid('subscription_plan.description')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="subscription_plan.amount"
									:label="`${$t('lang.amount')} *`"
									:counter="showCounter(subscription_plan.amount, 'subscription_plan.amount')"
									:rules="ifValid('subscription_plan.amount')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="subscription_plan.currency_code"
									:label="`${$t('lang.currency_code')} *`"
									:counter="showCounter(subscription_plan.currency_code, 'subscription_plan.currency_code')"
									:rules="ifValid('subscription_plan.currency_code')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="subscription_plan.term_months"
									:label="`${$t('lang.term_months')} *`"
									:rules="ifValid('subscription_plan.term_months')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="subscription_plan.is_active"
									:label="`${$t('lang.is_active')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('subscription_plan.is_active')"
								></bc-select>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="subscription_plan.zoho_item_id"
									:label="$t('lang.zoho_item_id')"
									:counter="showCounter(subscription_plan.zoho_item_id, 'subscription_plan.zoho_item_id')"
									:rules="ifValid('subscription_plan.zoho_item_id')"
								></v-text-field>
							</v-flex>


                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'subscription_plans' })" flat >{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @click="saveSubscriptionPlans">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_subscription_plan"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_subscription_plan')"
                :message="$t('lang.delete_subscription_plan_confirm')"
                @onConfirm="deleteSubscriptionPlans()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_subscription_plan_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteSubscriptionPlanDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            subscription_plan: { },
            file_name: "",
            dbGetSubscriptionPlan: _.debounce(this.getSubscriptionPlan, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchSubscriptionPlan", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.subscription_plan) {
                        this.subscription_plan = this.assignObj2(data.subscription_plan, this.rules_subscription_plans);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=subscription_plan_status&sort_by=2",
                            method: "get",
                            stateProperty: "subscription_plan_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "subscription_plans", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchSubscriptionPlan", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.subscription_plan) {
                        next((vm) => {
                            vm.subscription_plan = vm.assignObj2(data.subscription_plan, vm.rules_subscription_plans);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=subscription_plan_status&sort_by=2",
                                method: "get",
                                stateProperty: "subscription_plan_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "subscription_plans", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=subscription_plan_status&sort_by=2",
            method: "get",
            stateProperty: "subscription_plan_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_subscription_plans: (state) => state.subscription_plans.rules_subscription_plans,
            subscription_plan_status_options: (state) => state.settings.subscription_plan_status_options,
            subscription_plans: (state) => state.subscription_plans.subscription_plans,
            selectedSubscriptionPlan: (state) => state.subscription_plans.selectedSubscriptionPlan,

        }),
    },
    methods: {
        ...mapActions([
            "fetchSubscriptionPlan",
            "saveSubscriptionPlan",
            "deleteSubscriptionPlan",
            "printSubscriptionPlan",

        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getSubscriptionPlan(pg_refresh = false) {
            this.startLoader();

            this.fetchSubscriptionPlan({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.subscription_plan) {
                    this.subscription_plan = this.assignObj2(data.subscription_plan, this.rules_subscription_plans);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printSubscriptionPlan({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.subscription_plan) {
                    if (this.dev_mode) {
                        this.file_name = data.subscription_plan.file_name;
                    } else {
                        this.$refs.print.printReport(data.subscription_plan.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveSubscriptionPlans() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formSubscriptionPlan")) {
                    let body = this.prepForm(this.subscription_plan, this.rules_subscription_plans);

                    this.saveSubscriptionPlan({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.subscription_plan) {
                            this.$router.push({ name: "subscription_plan", params: { id: data.subscription_plan.plan_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { plan_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveSubscriptionPlans({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.subscription_plan) {
                    this.subscription_plan = this.assignObj2(data.subscription_plan, this.rules_subscription_plans);
                }
            });
        },
        deleteSubscriptionPlans() {
            this.deleteSubscriptionPlan({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {

                    this.validationOff();
                    this.$router.push({ name: "subscription_plans" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force=false) {
            this.startLoader();

            if (force == true) {
                await this.fetchSubscriptionPlan({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.subscription_plan) {
                        this.subscription_plan = this.assignObj2(data.subscription_plan, this.rules_subscription_plans);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }


        },
    },
    mounted() {
        this.refresh();
    },
    created() {
    },
};
</script>
